var r = /* @__PURE__ */ ((e) => (e.BUTTONS_END = "buttons-end", e.FILL_CONTAINER = "fill-container", e.SPACE_BETWEEN = "space-between", e.VERTICAL_STACK = "vertical-stack", e))(r || {}), T = /* @__PURE__ */ ((e) => (e.BUTTONS_START = "buttons-start", e))(T || {});
const E = { ...r, ...T };
export {
  E as ButtonActionsLayout,
  r as ButtonActionsLayoutBasic,
  T as ButtonActionsLayoutExtended
};
